import Direction from "../enums/direction";
import CanvasObject from "./canvasObject";

export default class Snake {
  colour = "blue";
  direction = Direction.RIGHT;
  initialSpeed = 200;
  initialBody = [new CanvasObject(20, 20, this.colour)];
  initialBodySize = 50;

  speed = this.initialSpeed;
  body = [...this.initialBody];
  bodySize = this.initialBodySize;

  getHead() {
    return this.body[0];
  }

  getTail() {
    //consider first 15 entries the 'head' of snake, return rest of entries
    return this.body.slice(15, this.body.length);
  }

  isFullSize() {
    return this.body.length === this.bodySize;
  }

  updateDirection(inputState) {
    if (inputState.up && this.direction !== Direction.DOWN) {
      this.direction = Direction.UP;
    } else if (inputState.down && this.direction !== Direction.UP) {
      this.direction = Direction.DOWN;
    } else if (inputState.left && this.direction !== Direction.RIGHT) {
      this.direction = Direction.LEFT;
    } else if (inputState.right && this.direction !== Direction.LEFT) {
      this.direction = Direction.RIGHT;
    }
  }

  updatePosition(deltaTime) {
    const headSegment = this.body[0];
    let newPosX = headSegment.x;
    let newPosY = headSegment.y;

    if (this.direction === Direction.LEFT) {
      newPosX -= this.speed * deltaTime;
    } else if (this.direction === Direction.RIGHT) {
      newPosX += this.speed * deltaTime;
    } else if (this.direction === Direction.UP) {
      newPosY -= this.speed * deltaTime;
    } else if (this.direction === Direction.DOWN) {
      newPosY += this.speed * deltaTime;
    }

    if (!this.isFullSize()) {
      this.body.unshift(new CanvasObject(newPosX, newPosY, this.colour));
    } else {
      this.body.pop();
    }
  }

  reset() {
    this.body = [...this.initialBody];
    this.bodySize = this.initialBodySize;
    this.direction = Direction.RIGHT;
    this.speed = this.initialSpeed;
  }

  grow() {
    this.bodySize += 10;
  }

  increaseSpeed() {
    this.speed += 10;
  }

  draw(context) {
    this.body.forEach((segment) => segment.draw(context));
  }
}
